export default "__VITE_ASSET__ab17616c__"